import React from 'react';

const ServitiLogo = ({ alt = 'Serviti AI', className = '', compact = false }) => (
  <span className={`serviti-brand-logo${compact ? ' serviti-brand-logo--compact' : ''} ${className}`} role="img" aria-label={alt}>
    <img className="serviti-brand-logo__light" src="/serviti_logo_dark.png" alt="" aria-hidden="true" />
    <img className="serviti-brand-logo__dark" src="/serviti_logo_white.png" alt="" aria-hidden="true" />
  </span>
);

export default ServitiLogo;
